import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ProdutoService from "./produtoService"
import FormList from 'base/FormList'
import { biggerThan } from 'helper/ui/responsive'
import { formatCurrency } from 'helper/formater'

export default function ProdutoList() {

    const [service] = useState(() => new ProdutoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_prod',
        dsName: 'descricao_prod',
        mainField: { name: 'descricao_prod', label: 'Unique ID' },
        advFields: [
            { name: 'codigo_prod', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'referencia_prod', label: 'Referência', type: 'string', inputMode: 'text' },
            { name: 'descricao_prod', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'descricao_resumida_prod', label: 'Descrição resumida', type: 'string', inputMode: 'text' },
            { name: 'ncm_prod', label: 'Nomenclatura comum do mercosul', type: 'string', inputMode: 'text' },
            { name: 'cest_prod', label: 'Código especificador da substituição tributária', type: 'string', inputMode: 'text' },
            { name: 'codigo_ean_prod', label: 'Código EAN', type: 'string', inputMode: 'text' },
            { name: 'codigo_barra_prod', label: 'Código de barras', type: 'string', inputMode: 'text' },
            { name: 'codigo_terceiro_prod', label: 'Código de terceiros', type: 'string', inputMode: 'text' },
            { name: 'codigo_anp_prod', label: 'Código ANP', type: 'string', inputMode: 'text' },
            { name: 'num_di_prod', label: 'Número de declaração de importação', type: 'string', inputMode: 'numeric' },
            { name: 'meta_descricao_prod', label: 'Meta descrição', type: 'string', inputMode: 'text' },
            { name: 'meta_key_prod', label: 'Meta key', type: 'string', inputMode: 'text' },
            { name: 'meta_titulo_prod', label: 'Meta título', type: 'string', inputMode: 'text' },
            { name: 'obs_nota_prod', label: 'Observação para nota fiscal', type: 'string', inputMode: 'text' },
            { name: 'ativo_prod', label: 'Ativo', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_prod" sortable header="Código" style={{ display: biggerThan('sm') }}></Column>
            <Column field="descricao_prod" sortable header="Descrição"></Column>
            <Column field="meta.preco_varejo_prem" sortable header="Preço" align='right' body={e => formatCurrency(e.meta.preco_varejo_prem)}></Column>
            <Column field="meta.estoque_atual_prem" sortable header="Estoque" align='right'></Column>
        </FormList >
    )
}
